import React, {useEffect, useRef} from "react";
import classNames from "classnames";

type SVVNavigationCardListProps = {
  ariaLabel?: string;
  minColumnWidth?: number
  autoFit?: boolean
  className?: string
} & React.PropsWithChildren<{}>;

const getHtmlElementFontSize = () => parseInt(window.getComputedStyle(document.documentElement).fontSize, 10) || 16

export function SVVNavigationCardList(
  {
    ariaLabel,
    children,
    minColumnWidth = 265,
    autoFit = false,
    className,
    ...restProps
  }: SVVNavigationCardListProps) {
  const navElementRef = useRef(null);

  useEffect(() => {
    if (navElementRef?.current) {
      navElementRef.current.style.setProperty(
        '--column-min-width', `${minColumnWidth / getHtmlElementFontSize()}rem`)
      navElementRef.current.style.setProperty(
        '--column-fill-mode', autoFit ? 'auto-fit' : 'auto-fill')
    }
  }, [minColumnWidth, autoFit]);
  return (
    <nav
      className={classNames("svv-navigation-card__list", className)}
      aria-label={ariaLabel}
      ref={navElementRef}
      {...restProps}
    >
      {children && children}
    </nav>
  );
}

SVVNavigationCardList.displayName = "SVVNavigationCardList";
